import { DBBCreateContractModalQueryKeys } from "components/DBB/components/DBBCreateContractModal/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";
import type { DBBStorageLocationID, DBBStorageLocationSummary, DealerLocation } from "models";

const selectStorageLocationOptions = (storageLocations: DBBStorageLocationSummary[]): DropdownItemProps<DBBStorageLocationID>[] =>
  storageLocations.map(({ id, name, sub_location_name }) => ({ key: id, value: id, text: name, description: sub_location_name }));

export const usePermanentStorageLocationOptionsQuery = (carLocation?: DealerLocation) =>
  useTypedQuery({
    queryKey: DBBCreateContractModalQueryKeys.storageLocations(carLocation?.id),
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.storage_locations ?? [],
    enabled: !!carLocation?.dbb_enabled,
    select: selectStorageLocationOptions
  });
